import { IAftnMessage, IAirep } from "@naviair-utm/node-shared-interfaces";
import { dateParser, timeParser, trimmer } from "../CommonParsers";
import {
  airepIcaoParser,
  airepTypeParser,
  bodyParser,
  flightLevelParser,
} from "./AirepParsers";
import { dateTimeRegex, timeRegex } from "./AirepRegExp";

/**
 * Parse an airep message and output IAirep or an error message if any errors
 * @param {string} input The airep string
 * @returns {IAirep}
 */
export const airepParser = (input: string): IAftnMessage<IAirep> => {
  let airepParsed: IAftnMessage<IAirep> = {} as IAftnMessage<IAirep>;
  airepParsed.type = "AIREP";
  airepParsed.parsedMessage = {} as IAirep;

  // Trimmer to replace multiple consecutive whitespaces with a single
  const trimmedAirep = trimmer(input);
  airepParsed.rawInput = trimmedAirep;

  // ICAO code
  const icao = airepIcaoParser(trimmedAirep);
  if (icao !== null) {
    airepParsed.icao = icao;
  }

  // Check for airep type (normal or special/urgent)
  const airepType = airepTypeParser(trimmedAirep);
  if (airepType !== null) {
    airepParsed.parsedMessage.airepType = airepType;
  } else {
    airepParsed.errors.push("No airep type specified (normal/special/urgent");
  }

  // Get the date issued by using the common parser for this
  const dateIssued = dateParser(trimmedAirep, dateTimeRegex);
  if (dateIssued) {
    airepParsed.validity = {};
    airepParsed.validity.start = dateIssued.toDate();
  } else {
    airepParsed.errors.push("Failed getting date issued");
  }

  // Get the time the phenomenon were observed
  const timeObserved = timeParser(trimmedAirep, timeRegex);
  if (timeObserved) {
    airepParsed.parsedMessage.timeObserved = timeObserved.toDate();
  }

  // Get flight level which might be a single level or an interval
  const flightLevel = flightLevelParser(trimmedAirep);
  if (flightLevel) {
    airepParsed.parsedMessage.flightLevel = flightLevel;
  }

  const body = bodyParser(trimmedAirep);
  if (body) {
    airepParsed.parsedMessage.body = body;
  } else {
    airepParsed.errors.push("Failed to parse body of airep");
  }

  return airepParsed;
};
